import axiosRequest from '../constants/axios-request'
import { Category } from '../types/training'

export const getCategory = (
  categoryId: string | undefined
): Promise<Category> =>
  axiosRequest.get(`/category/${categoryId}`).then((result) => result.data)

export const addCategory = (payload: {
  category: Omit<Category, 'parts' | 'id' | 'status'>
  trainingId: string
}): Promise<number> =>
  axiosRequest
    .post(`/category`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updateCategory = (
  categoryId: string,
  payload: Omit<Category, 'parts' | 'id' | 'status'>
): Promise<number> =>
  axiosRequest
    .put(`/category/${categoryId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const deleteCategory = (
  categoryId: string | undefined
): Promise<number> =>
  axiosRequest
    .delete(`/admin/category/${categoryId}`)
    .then((result) => result.status)
    .catch((error) => error.response.status)
